import { useIsMobile } from 'epion-checkin/hooks/use-is-mobile';
import { Countly } from 'modules/countly';
import { createContext, FC, PropsWithChildren, useCallback, useMemo } from 'react';

export interface CaptureCountlyEvents {
    addCountlyEvent: typeof Countly.addEvent;
}

export const CaptureCountlyEventsContext = createContext<CaptureCountlyEvents | undefined>(undefined);

CaptureCountlyEventsContext.displayName = 'CaptureCountlyEventsContext';

export const CaptureCountlyEventsContextProvider: FC<PropsWithChildren<{ departmentId: string | undefined }>> = ({
    children,
    departmentId,
}) => {
    const isMobile = useIsMobile();

    const addCountlyEvent: typeof Countly.addEvent = useCallback(
        ({ key, segmentation }) => {
            Countly.addEvent({
                key,
                segmentation: {
                    departmentId,
                    schedulerType: 'checkin',
                    viewportType: isMobile ? 'Mobile' : 'Tablet',
                    ...segmentation,
                },
            });
        },
        [departmentId, isMobile]
    );

    const contextValue = useMemo(() => ({ addCountlyEvent }), [addCountlyEvent]);

    return <CaptureCountlyEventsContext.Provider value={contextValue}>{children}</CaptureCountlyEventsContext.Provider>;
};
